export const moneyMaskProperties = {
    options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        precision: 2
    },
    properties: {
        rounded: true,
        filled: true,
        class: 'custom'
    }
}
